import {Translate} from 'app/services/translate';
import {StringHelper} from 'app/lib/stringHelper';

export const ERROR_SOURCES = {
    '/data/attributes/email': 'email',
    '/data/attributes/password': 'password',
};

export const ERROR_CONTENT = {
    'email_already_taken': Translate('commons_form_errors_email_already_taken'),
    'social_email_already_taken': Translate('commons_form_errors_social_email_already_taken'),
    'not_blank': Translate('commons_form_errors_not_blank'),
    'not_blank_is_blank_error': Translate('commons_form_errors_not_blank'),
    'invalid_email': Translate('commons_form_errors_invalid_email'),
    'invalid_phone': Translate('commons_form_errors_invalid_phone'),
    'invalid_username': Translate('commons_form_errors_invalid_username'),
    'invalid_grant': Translate('commons_form_errors_invalid_grant'),
    'login_blocked': Translate('commons_form_errors_login_blocked'),
    'password_strength': Translate('commons_form_errors_weak_password'),
    'login_attempt_error': StringHelper.newLineToBrTag(Translate('commons_form_errors_login_attempt_error')),
    'register_attempt_error': StringHelper.newLineToBrTag(Translate('commons_form_errors_register_attempt_error')),
    'unknown_error': Translate('commons_form_errors_unknown_error'),
};
